import { DefaultTheme } from 'styled-components';

const defaultTheme: DefaultTheme = {
  palette: {
    alto: '#d9d9d9',
    transparent: 'transparent',
    white: '#ffffff',
    scienceblue: '#0b6ed6',
    dodgerBlue: '#40a9ff',
    scorpion: '#595757',
  },
  font: {
    Light: 'Light',
    Regular: 'Regular',
    Medium: 'Medium',
    Bold: 'Bold',
  },
};

export default defaultTheme;
